// @ts-nocheck
(function () {
  'use strict';

  var STORAGE_KEY = 'attribution_data';
  var DEBUG_KEY = 'attribution_debug';
  var SUPPORTED_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'utm_agent',
    'gclid',
    'fbclid',
    'msclkid',
    'ttclid',
    'dclid',
    'ref',
    'affiliate',
    'c',
    'oid',
    'affid',
    'sub1',
    'sub2',
  ];

  function safeJsonParse(value, fallbackValue) {
    if (!value) return fallbackValue;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallbackValue;
    }
  }

  function safeStorageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function getCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function getEftidFromCookie() {
    try {
      var cookies = document.cookie.split(';');
      var lastValue = '';
      for (var i = 0; i < cookies.length; i++) {
        var pair = cookies[i].trim();
        if (pair.indexOf('ef_tid_') === 0) {
          var eqIndex = pair.indexOf('=');
          if (eqIndex !== -1) {
            var val = decodeURIComponent(pair.substring(eqIndex + 1));
            if (val) lastValue = val;
          }
        }
      }
      return lastValue;
    } catch (error) {
      return '';
    }
  }

  function isDebugEnabled() {
    return safeStorageGet(DEBUG_KEY) === '1';
  }

  function logDebug() {
    if (!isDebugEnabled()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Attribution]');
    console.log.apply(console, args);
  }

  function getStoredAttribution() {
    var raw = safeStorageGet(STORAGE_KEY);
    var parsed = safeJsonParse(raw, null);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {};
    }
    return parsed;
  }

  function setStoredAttribution(data) {
    return safeStorageSet(STORAGE_KEY, JSON.stringify(data));
  }

  function extractSupportedParams(searchParams) {
    var result = {};
    for (var i = 0; i < SUPPORTED_PARAMS.length; i++) {
      var key = SUPPORTED_PARAMS[i];
      var value = searchParams.get(key);
      if (value) result[key] = value;
    }
    return result;
  }

  function normalizeEverflowParams(urlObject) {
    var params = urlObject.searchParams;
    var oid = params.get('oid');
    var affid = params.get('affid');

    if (!oid || !affid) return false;

    var modified = false;
    if (!params.get('utm_source')) {
      params.set('utm_source', 'everflow');
      modified = true;
    }
    if (!params.get('utm_medium')) {
      params.set('utm_medium', 'influencers');
      modified = true;
    }
    if (!params.get('utm_campaign')) {
      params.set('utm_campaign', affid);
      modified = true;
    }
    if (!params.get('utm_id')) {
      params.set('utm_id', affid);
      modified = true;
    }

    return modified;
  }

  function captureFromCurrentUrl() {
    var urlObject = new URL(window.location.href);
    var incoming = extractSupportedParams(urlObject.searchParams);
    var urlModified = normalizeEverflowParams(urlObject);
    if (urlModified) {
      window.history.replaceState({}, '', urlObject.toString());
    }

    var normalizedIncoming = extractSupportedParams(urlObject.searchParams);
    var normalizedKey;
    for (normalizedKey in normalizedIncoming) {
      if (Object.prototype.hasOwnProperty.call(normalizedIncoming, normalizedKey)) {
        incoming[normalizedKey] = normalizedIncoming[normalizedKey];
      }
    }

    var hasIncoming = Object.keys(incoming).length > 0;
    var stored = getStoredAttribution();
    var merged = {};
    var key;

    for (key in stored) {
      if (Object.prototype.hasOwnProperty.call(stored, key)) {
        merged[key] = stored[key];
      }
    }
    for (key in incoming) {
      if (Object.prototype.hasOwnProperty.call(incoming, key)) {
        merged[key] = incoming[key];
      }
    }

    if (hasIncoming || !merged.landing_page) {
      merged.landing_page = urlObject.pathname + urlObject.search;
    }
    if (hasIncoming || !merged.utm_captured_at) {
      merged.utm_captured_at = new Date().toISOString();
    }
    if (document.referrer && (hasIncoming || !merged.referrer)) {
      merged.referrer = document.referrer;
    }

    var cookieEftid = getEftidFromCookie();
    if (cookieEftid) {
      merged.eftid = cookieEftid;
    }

    setStoredAttribution(merged);
    logDebug('Captured attribution', merged);
    return merged;
  }

  function getAttribution() {
    return getStoredAttribution();
  }

  function buildCartAttributesPayload() {
    var source = getStoredAttribution();
    var attributes = {};

    function add(targetKey, sourceKey) {
      var value = source[sourceKey];
      if (typeof value === 'string' && value.length > 0) {
        attributes[targetKey] = value;
      }
    }

    add('utm_source', 'utm_source');
    add('utm_medium', 'utm_medium');
    add('utm_campaign', 'utm_campaign');
    add('utm_term', 'utm_term');
    add('utm_content', 'utm_content');
    add('utm_id', 'utm_id');
    add('utm_agent', 'utm_agent');
    add('gclid', 'gclid');
    add('fbclid', 'fbclid');
    add('msclkid', 'msclkid');
    add('ttclid', 'ttclid');
    add('dclid', 'dclid');
    add('eftid', 'eftid');

    var liveEftid = resolveEftid();
    if (liveEftid) {
      attributes.eftid = liveEftid;
      if (!source.eftid) {
        storeEftid(liveEftid);
      }
    }

    add('affiliate', 'affiliate');
    add('ref', 'ref');
    add('campaign_code', 'c');
    add('oid', 'oid');
    add('affid', 'affid');
    add('sub1', 'sub1');
    add('sub2', 'sub2');
    add('landing_page', 'landing_page');
    add('utm_captured_at', 'utm_captured_at');

    return attributes;
  }

  function appendMarketingParamsToUrl(inputUrl) {
    if (!inputUrl) return inputUrl;
    try {
      var urlObj = new URL(inputUrl, window.location.origin);
      var data = getStoredAttribution();
      for (var i = 0; i < SUPPORTED_PARAMS.length; i++) {
        var key = SUPPORTED_PARAMS[i];
        var value = data[key];
        if (value) urlObj.searchParams.set(key, value);
      }
      return urlObj.toString();
    } catch (error) {
      return inputUrl;
    }
  }

  function getShopifyRoot() {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      root = window.Shopify.routes.root;
    }
    if (root.charAt(0) !== '/') root = '/' + root;
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function buildThemePath(pathSegment) {
    var segment = pathSegment || '';
    if (segment.charAt(0) === '/') segment = segment.slice(1);
    return getShopifyRoot() + segment;
  }

  function getCheckoutSubmitUrl(form, trigger) {
    var triggerAction = trigger && trigger.getAttribute && trigger.getAttribute('formaction');
    var formAction = form && form.getAttribute && form.getAttribute('action');
    var absoluteFormAction = form && form.action;
    var candidate = triggerAction || formAction || absoluteFormAction || '';

    if (candidate) {
      try {
        var parsed = new URL(candidate, window.location.origin);
        if (parsed.origin === window.location.origin && /\/checkout($|\/|\?)/.test(parsed.pathname)) {
          return parsed.toString();
        }
      } catch (error) {
        return candidate;
      }
    }

    return buildThemePath('checkout');
  }

  function isEligibleCheckoutAnchor(href) {
    if (!href) return false;
    try {
      var parsed = new URL(href, window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      return /\/checkout($|\/|\?)/.test(parsed.pathname);
    } catch (error) {
      return false;
    }
  }

  function setHiddenInput(form, name, value) {
    var selector = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function getVariantSkuFromForm(form) {
    var explicit = form.querySelector('input[name="properties[_variant_sku]"]');
    if (explicit && explicit.value) return explicit.value;

    var variantInput = form.querySelector('input[name="id"][data-sku]');
    if (variantInput && variantInput.dataset && variantInput.dataset.sku) {
      return variantInput.dataset.sku;
    }

    var variantSelect = form.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.options && variantSelect.selectedIndex > -1) {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt && opt.dataset && opt.dataset.sku) return opt.dataset.sku;
    }

    return '';
  }

  function getProductIdFromForm(form) {
    if (form && form.dataset && form.dataset.productId) return form.dataset.productId;
    if (form && form.getAttribute) {
      var directProductId = form.getAttribute('data-productid');
      if (directProductId) return directProductId;
    }

    var productIdInput =
      form &&
      form.querySelector &&
      form.querySelector('input[name="product-id"], input[name="product_id"], input[name="productId"]');
    if (productIdInput && productIdInput.value) {
      return productIdInput.value;
    }

    var formComponent = form && form.closest && form.closest('product-form-component');
    if (formComponent && formComponent.dataset && formComponent.dataset.productId) {
      return formComponent.dataset.productId;
    }

    var quickOrderComponent = form && form.closest && form.closest('quick-order-list-component');
    if (quickOrderComponent && quickOrderComponent.dataset && quickOrderComponent.dataset.productId) {
      return quickOrderComponent.dataset.productId;
    }

    var genericProductContainer = form && form.closest && form.closest('[data-product-id]');
    if (genericProductContainer && genericProductContainer.dataset && genericProductContainer.dataset.productId) {
      return genericProductContainer.dataset.productId;
    }

    var genericProductIdContainer = form && form.closest && form.closest('[data-productid]');
    if (genericProductIdContainer && genericProductIdContainer.getAttribute) {
      var genericProductId = genericProductIdContainer.getAttribute('data-productid');
      if (genericProductId) return genericProductId;
    }

    return '';
  }

  function getProductTypeFromForm(form) {
    if (!form) return '';

    var formType = form.getAttribute('data-product-type');
    if (formType) return String(formType).toLowerCase();

    var formComponent = form.closest && form.closest('product-form-component');
    if (formComponent && formComponent.dataset && formComponent.dataset.productType) {
      return String(formComponent.dataset.productType).toLowerCase();
    }

    var genericProductContainer = form.closest && form.closest('[data-product-type]');
    if (genericProductContainer && genericProductContainer.dataset && genericProductContainer.dataset.productType) {
      return String(genericProductContainer.dataset.productType).toLowerCase();
    }

    return '';
  }

  function isBundleProductType(value) {
    if (!value) return false;
    return String(value).toLowerCase().trim().indexOf('bundle') !== -1;
  }

  function getSelectedVariantIdFromForm(form) {
    if (!form) return '';
    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) return String(variantInput.value);

    var variantSelect = form.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) return String(variantSelect.value);

    return '';
  }

  function getVariantPropertiesMap(form) {
    var serializedMap = form.getAttribute('data-attribution-variant-properties');
    var formComponent = form.closest && form.closest('product-form-component');
    if (!serializedMap && formComponent) {
      serializedMap = formComponent.getAttribute('data-attribution-variant-properties');
    }

    var parsedMap = safeJsonParse(serializedMap, null);
    if (parsedMap && typeof parsedMap === 'object' && !Array.isArray(parsedMap)) {
      return parsedMap;
    }

    return {};
  }

  function getConfigFromForm(form) {
    var config = {};
    var serializedConfig = form.getAttribute('data-attribution-line-properties');
    var formComponent = form.closest && form.closest('product-form-component');
    if (!serializedConfig && formComponent) {
      serializedConfig = formComponent.getAttribute('data-attribution-line-properties');
    }
    var parsedConfig = safeJsonParse(serializedConfig, null);
    if (parsedConfig && typeof parsedConfig === 'object' && !Array.isArray(parsedConfig)) {
      config = parsedConfig;
    }
    return config;
  }

  function buildLineItemProperties(form, variantIdOverride) {
    var properties = {};
    var config = getConfigFromForm(form);
    var variantId = variantIdOverride ? String(variantIdOverride) : getSelectedVariantIdFromForm(form);
    var variantMap = getVariantPropertiesMap(form);
    var variantScopedConfig = variantMap[variantId];

    if (variantScopedConfig && typeof variantScopedConfig === 'object' && !Array.isArray(variantScopedConfig)) {
      for (var key in variantScopedConfig) {
        if (Object.prototype.hasOwnProperty.call(variantScopedConfig, key)) {
          config[key] = variantScopedConfig[key];
        }
      }
    }

    var sku = typeof config._variant_sku === 'string' ? config._variant_sku : getVariantSkuFromForm(form);
    if (sku) {
      properties._variant_sku = String(sku);
    }

    var productId = getProductIdFromForm(form);
    if (productId) {
      properties._product_id = String(productId);
    }

    var optionalPropertyKeys = [
      '_isbundle',
      '_lot_number',
      '_bundle_quantity',
      '_warehouse',
      '_one_time_purchase_price',
      '_upsell',
    ];

    for (var i = 0; i < optionalPropertyKeys.length; i++) {
      var propertyKey = optionalPropertyKeys[i];
      var value = config[propertyKey];

      if (value === undefined || value === null || value === '') {
        continue;
      }

      properties[propertyKey] = String(value);
    }

    if (isBundleProductType(getProductTypeFromForm(form))) {
      if (!properties._isbundle) {
        properties._isbundle = 'true';
      }

      if (!properties._bundle_quantity) {
        properties._bundle_quantity =
          config._bundle_quantity !== undefined && config._bundle_quantity !== null && config._bundle_quantity !== ''
            ? String(config._bundle_quantity)
            : '1';
      }
    }

    return properties;
  }

  function attachLineItemProperties(form) {
    var properties = buildLineItemProperties(form);
    for (var key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        setHiddenInput(form, 'properties[' + key + ']', properties[key]);
      }
    }
  }

  function isAddToCartForm(form) {
    if (!form || !form.matches) return false;
    if (form.getAttribute('data-type') === 'add-to-cart-form') return true;
    if (/\/cart\/add(\.js)?($|\?)/.test(form.getAttribute('action') || '')) return true;
    return false;
  }

  function bindProductFormHooks(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (!isAddToCartForm(form) || form.dataset.attributionBound === '1') continue;
      form.dataset.attributionBound = '1';

      form.addEventListener('submit', function (event) {
        attachLineItemProperties(event.currentTarget);
      });
    }
  }

  function doSyncCartAttributes(extraAttributes) {
    var attributes = buildCartAttributesPayload();
    if (extraAttributes && typeof extraAttributes === 'object') {
      for (var key in extraAttributes) {
        if (Object.prototype.hasOwnProperty.call(extraAttributes, key)) {
          attributes[key] = extraAttributes[key];
        }
      }
    }

    logDebug('Syncing cart attributes', attributes);
    return fetch(buildThemePath('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart attribute sync failed with status ' + response.status);
      }
      return response.json();
    });
  }

  function syncCartAttributes(extraAttributes) {
    if (_eftidResolved || resolveEftid()) {
      return doSyncCartAttributes(extraAttributes);
    }

    return new Promise(function (resolve, reject) {
      var waited = 0;
      var checkInterval = setInterval(function () {
        waited += 100;
        var tid = getEftidFromSdk() || getEftidFromCookie();
        if (tid) {
          clearInterval(checkInterval);
          storeEftid(tid);
          doSyncCartAttributes(extraAttributes).then(resolve, reject);
        } else if (waited >= 3000) {
          clearInterval(checkInterval);
          logDebug('eftid not available after 3s wait, syncing without it');
          doSyncCartAttributes(extraAttributes).then(resolve, reject);
        }
      }, 100);
    });
  }

  function decorateCheckoutLinks(root) {
    var scope = root || document;

    var checkoutAnchors = scope.querySelectorAll('a[href*="/checkout"]');
    for (var i = 0; i < checkoutAnchors.length; i++) {
      var anchor = checkoutAnchors[i];
      var href = anchor.getAttribute('href');
      if (isEligibleCheckoutAnchor(href)) {
        anchor.setAttribute('href', appendMarketingParamsToUrl(href));
      }
    }

    var checkoutButtons = scope.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    for (var j = 0; j < checkoutButtons.length; j++) {
      var button = checkoutButtons[j];
      if (button.dataset.checkoutAttributionBound === '1') continue;
      button.dataset.checkoutAttributionBound = '1';

      button.addEventListener('click', function (event) {
        var target = event.currentTarget;
        var form = target && target.form;
        if (!form) return;
        var checkoutUrl = getCheckoutSubmitUrl(form, target);
        target.setAttribute('formaction', appendMarketingParamsToUrl(checkoutUrl));
      });
    }
  }

  function bindCheckoutDelegates() {
    if (document.documentElement.dataset.checkoutAttributionDelegateBound === '1') return;
    document.documentElement.dataset.checkoutAttributionDelegateBound = '1';

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var checkoutTrigger = target.closest('button[name="checkout"], input[name="checkout"]');
        if (checkoutTrigger && checkoutTrigger.form) {
          var submitUrl = getCheckoutSubmitUrl(checkoutTrigger.form, checkoutTrigger);
          checkoutTrigger.setAttribute('formaction', appendMarketingParamsToUrl(submitUrl));
          return;
        }

        var checkoutAnchor = target.closest('a[href*="/checkout"]');
        if (checkoutAnchor) {
          var href = checkoutAnchor.getAttribute('href');
          if (isEligibleCheckoutAnchor(href)) {
            checkoutAnchor.setAttribute('href', appendMarketingParamsToUrl(href));
          }
        }
      },
      true
    );
  }

  var EVERFLOW_ADVERTISER_ID = 2;
  var _eftidResolved = false;

  function getEftidFromSdk() {
    if (window.EF && typeof window.EF.getAdvertiserTransactionId === 'function') {
      try {
        var tid = window.EF.getAdvertiserTransactionId(EVERFLOW_ADVERTISER_ID);
        if (tid) return String(tid);
      } catch (e) {
        // SDK not ready yet
      }
    }
    return '';
  }

  function resolveEftid() {
    var tid = getEftidFromSdk() || getEftidFromCookie();
    if (!tid) {
      var stored = getStoredAttribution();
      if (stored.eftid) tid = stored.eftid;
    }
    return tid || '';
  }

  function pollEverflowTransactionId() {
    var tid = getEftidFromSdk();
    if (tid) {
      storeEftid(tid);
      return;
    }

    var attempts = 0;
    var maxAttempts = 150;
    var interval = setInterval(function () {
      attempts++;
      tid = getEftidFromSdk() || getEftidFromCookie();
      if (tid) {
        clearInterval(interval);
        storeEftid(tid);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        logDebug('Everflow SDK polling exhausted after 30s, no eftid found');
      }
    }, 200);
  }

  function storeEftid(tid) {
    _eftidResolved = true;
    var stored = getStoredAttribution();
    if (stored.eftid === tid) return;
    stored.eftid = tid;
    setStoredAttribution(stored);
    logDebug('Everflow eftid captured:', tid);
    syncCartAttributes().catch(function () {});
  }

  function init(options) {
    if (options && options.debug === true) safeStorageSet(DEBUG_KEY, '1');
    if (options && options.debug === false) safeStorageSet(DEBUG_KEY, '0');

    captureFromCurrentUrl();
    pollEverflowTransactionId();
    bindProductFormHooks(document);
    decorateCheckoutLinks(document);
    bindCheckoutDelegates();
  }

  window.Attribution = {
    init: init,
    captureFromCurrentUrl: captureFromCurrentUrl,
    getAttribution: getAttribution,
    buildCartAttributesPayload: buildCartAttributesPayload,
    appendMarketingParamsToUrl: appendMarketingParamsToUrl,
    bindProductFormHooks: bindProductFormHooks,
    attachLineItemProperties: attachLineItemProperties,
    buildLineItemProperties: buildLineItemProperties,
    syncCartAttributes: syncCartAttributes,
    decorateCheckoutLinks: decorateCheckoutLinks,
    bindCheckoutDelegates: bindCheckoutDelegates,
    enableDebug: function () {
      safeStorageSet(DEBUG_KEY, '1');
    },
    disableDebug: function () {
      safeStorageSet(DEBUG_KEY, '0');
    },
  };
  // Backward-compatible alias
  window.AQTAttribution = window.Attribution;
})();
